import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M22.5 0h-21A1.5 1.5 0 0 0 0 1.5v16A1.5 1.5 0 0 0 1.5 19h21a1.5 1.5 0 0 0 1.5-1.5v-16A1.5 1.5 0 0 0 22.5 0M2 14.5v-12a.5.5 0 0 1 .5-.5h19a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5m14.45 8.71-2.1-2.53a.53.53 0 0 0-.35-.18h-4a.53.53 0 0 0-.38.18l-2.1 2.53a.49.49 0 0 0 0 .52A.48.48 0 0 0 8 24h8a.51.51 0 0 0 .41-.79Z"
    }, null, -1)
  ]));
}
const computerDeviceDesktopMonitor = { render };
export {
  computerDeviceDesktopMonitor as default,
  render
};
//# sourceMappingURL=computer-device-desktop-monitor.svg.js.map
